import { helpers } from '@vuelidate/validators';

/**
 * Validates CVVs.
 */
export default helpers.withParams(
  { type: 'cvv', message: 'Security Code does not match the required format.' },
  value => /[0-9]{3,4}$/.test(value),
);
